module.exports = __webpack_public_path__ + "static/media/bg.265d1e0d.png";